import { render, staticRenderFns } from "./campania.vue?vue&type=template&id=22c3e89b&"
import script from "./campania.vue?vue&type=script&lang=js&"
export * from "./campania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports